module.exports = __webpack_public_path__ + "static/women-computer-science-800x500-d420453bb1dec08b35e40f758b4c5dd0.jpg";